<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="bold"
    enable-background="new 0 0 24 24"
    height="512"
    viewBox="0 0 24 24"
    width="512"
  >
    <title>ReadMe...</title>
    <path
      d="m12.25 2h-1.1c-.33-1.15-1.39-2-2.65-2s-2.32.85-2.65 2h-1.1c-.41 0-.75.34-.75.75v1.5c0 .96.79 1.75 1.75 1.75h5.5c.96 0 1.75-.79 1.75-1.75v-1.5c0-.41-.34-.75-.75-.75z"
    />
    <path
      d="m14.25 3h-.25v1.25c0 1.52-1.23 2.75-2.75 2.75h-5.5c-1.52 0-2.75-1.23-2.75-2.75v-1.25h-.25c-1.52 0-2.75 1.23-2.75 2.75v12.5c0 1.52 1.23 2.75 2.75 2.75h6.59c-.5-1.07-.8-2.25-.83-3.5h-4.76c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4.84c.09-.61.24-1.19.44-1.75h-5.28c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6c.39-.64.85-1.23 1.39-1.75h-7.39c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h9.44c1.15-.6 2.44-.96 3.81-.99v-2.76c0-1.52-1.23-2.75-2.75-2.75z"
    />
    <path
      d="m17.25 10.5c-3.722 0-6.75 3.028-6.75 6.75s3.028 6.75 6.75 6.75 6.75-3.028 6.75-6.75-3.028-6.75-6.75-6.75zm1 9.5c0 .552-.447 1-1 1s-1-.448-1-1v-3.5c0-.552.447-1 1-1s1 .448 1 1zm-1-5c-.552 0-1-.448-1-1s.448-1 1-1 1 .448 1 1-.448 1-1 1z"
    />
  </svg>
</template>

<script>
export default {};
</script>